import axios from 'axios';
import { axiosPath } from '../../routing/helpers/router';
import { captureAxiosError } from '@/minions/error';

export const SET_URL_DATA = 'SET_URL_DATA';
export const SET_BREADCRUMB = 'SET_BREADCRUMB';
export const FETCH_LANGUAGES = 'FETCH_LANGUAGES';
export const SET_SIDEBAR_STATUS = 'SET_SIDEBAR_STATUS';
export const FETCH_CATEGORIES = 'FETCH_CATEGORIES';
export const FETCH_NOTES = 'FETCH_NOTES';
export const FETCH_PERMISSIONS = 'FETCH_PERMISSIONS';
export const SET_ROUTE = 'SET_ROUTE';

export const setUrlData = (req) => (dispatch) => {
  dispatch({ type: SET_URL_DATA, payload: req });
};

export const setBreadcrumb = (req) => (dispatch) => {
  dispatch({ type: SET_BREADCRUMB, payload: req });
};

export const fetchLanguages = () => async (dispatch) => {
  try {
    const response = await axios.post(
      axiosPath('api_r_user_global_getLanguages')
    );
    if (!response.data.error)
      dispatch({ type: FETCH_LANGUAGES, payload: response.data });
  } catch (err) {
      captureAxiosError(err);
  }
};

export const setIsSidebar = (req) => (dispatch) => {
  dispatch({ type: SET_SIDEBAR_STATUS, payload: req });
};

export const setRoute = (req) => (dispatch) => {
  dispatch({ type: SET_ROUTE, payload: req });
};

export const fetchCategories = () => async (dispatch) => {
  try {
    const response = await axios.post(
      axiosPath('api_r_user_global_getCategories')
    );
    if (!response.data.error)
      dispatch({ type: FETCH_CATEGORIES, payload: response.data });
  } catch (err) {
      captureAxiosError(err);
  }
};

export const fetchNotes = () => async (dispatch) => {
  try {
    const response = await axios.post(
      axiosPath('api_r_user_global_getCategories')
    );
    if (!response.data.error)
      dispatch({ type: FETCH_NOTES, payload: response.data });
  } catch (err) {
      captureAxiosError(err);
  }
};

export const fetchPermissions = (req) => async (dispatch) => {
  try {
    const response = await axios.post(
      axiosPath('api_r_user_global_permissions_get'),
      req
    );
    if (!response.data.error)
      dispatch({ type: FETCH_PERMISSIONS, payload: response.data });
  } catch (err) {
      captureAxiosError(err);
  }
};
